import { render } from "./OpenResponseQuestionMultiAI.vue?vue&type=template&id=cff7e3c2&ts=true"
import script from "./OpenResponseQuestionMultiAI.vue?vue&type=script&lang=ts"
export * from "./OpenResponseQuestionMultiAI.vue?vue&type=script&lang=ts"

import "./OpenResponseQuestionMultiAI.vue?vue&type=style&index=0&id=cff7e3c2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__